import { Subscription } from '@/app/types/database/Subscription';
import React from 'react';

interface IProps {
  subscription: Subscription;
}

export default function CanceledBanner(props: IProps) {
  return (
    <>
      {props.subscription.isCancelled && (
        <div style={{ maxWidth: 300 }}>
          <div className="bordered mt-4 flex gap-2 border-2 border-solid border-secondary border-white p-4 align-middle">
            <div className="font-bold">
              Your have canceled your Pro Subscription. Your Limbiks Pro
              subscription will be discontinued on{' '}
              {props.subscription.cancelDate.toLocaleDateString()}.
            </div>
          </div>
        </div>
      )}
    </>
  );
}
